import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Language, ConfigSchema } from '../api/types/config';

/**
 * Slice containing some app wide data loaded from config
 * 
 */

export interface ConfigState {
    languages: Array<Language>
    defaultLanguage: string;
}

export const initialState: ConfigState = {
    languages: [],
    defaultLanguage: '',
}

const configSlice = createSlice({
    name: 'config',
    initialState,
    reducers: {
        setConfig(state, action:PayloadAction<ConfigSchema>) {
            const conf = action.payload;
            state.languages = conf.languages;
            state.defaultLanguage = conf.default_language;
        }
    }
});

export const {
    setConfig,
} = configSlice.actions;
  
export default configSlice.reducer;